import schedule_img from '@/public/article/Access Critical Data for Improved Service.webp';
import app_img from '@/public/article/App.webp';
import estimate_img from '@/public/article/Estimate_1.webp';
import invoicing from '@/public/article/Invoice.webp';
import article1 from '@/public/article/picture.webp';
import route_img from '@/public/article/Route Optimization.webp';
import main_bg from '@/public/industries/carpet_cleaning/main.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'Does My Carpet Cleaning Business Need Software?',
    text: 'Yes, specialized software like Orcatec can significantly enhance your business efficiency, especially in scheduling, dispatch, and customer relationship management.',
  },
  {
    title: 'Is Orcatec Carpet Cleaning Software Free?',
    text: `Orcatec offers a free starter package with basic features, allowing you to upgrade as your business needs to expand.`,
  },
  {
    title: 'Does Orcatec Have a Carpet Cleaning App?',
    text: 'Yes, a mobile app through the Orcatec, and you can download it on any phone with the support of the iOS or Android system and always keep your business in your hands.',
  },
  {
    title: 'What is Carpet Cleaning CRM?',
    text: 'Carpet cleaning CRM helps manage customer interactions, improving satisfaction and retention by keeping detailed records and communication logs.',
  },
  {
    title: 'How Does Carpet Cleaning Scheduling Software Work?',
    text: 'A software for carpet cleaning business allows for an automated booking module. You can now make the bookings and continue running your business as the software dispatches and tracks them in real-time to minimize scheduling conflicts and no-shows through notifications.',
  },
];

const testimonals = [
  {
    text: `Since we started using Orcatec for our carpet cleaning services, the difference has been clear. Our teams are more coordinated, and thanks to the improved communication features, we're seeing a significant uptick in repeat clients.`,
    name: 'Tim Reynolds, ',
    position: 'Owner, Reynolds Carpet Care',
  },

  {
    text: `Orcatec's software has transformed how we manage our daily operations. The billing feature is a game changer – no more delayed payments! Our customers appreciate the ease of use and prompt service.  `,
    name: 'Lisa Chang, ',
    position: 'General Manager, FreshFiber Carpets',
  },
  {
    text: `The route optimization tool in Orcatec's software has saved us countless hours. We can serve more customers with less downtime, directly impacting our bottom line. Highly recommend it for any carpet cleaning business looking to grow.`,
    name: 'Derek M., ',
    position: 'Operations Director, CleanSweep Services',
  },
  {
    text: `Since we started using Orcatec for our carpet cleaning services, the difference has been clear. Our teams are more coordinated, and thanks to the improved communication features, we're seeing a significant uptick in repeat clients.`,
    name: 'Tim Reynolds, ',
    position: 'Owner, Reynolds Carpet Care',
  },

  {
    text: `Orcatec's software has transformed how we manage our daily operations. The billing feature is a game changer – no more delayed payments! Our customers appreciate the ease of use and prompt service.  `,
    name: 'Lisa Chang, ',
    position: 'General Manager, FreshFiber Carpets',
  },
  {
    text: `The route optimization tool in Orcatec's software has saved us countless hours. We can serve more customers with less downtime, directly impacting our bottom line. Highly recommend it for any carpet cleaning business looking to grow.`,
    name: 'Derek M., ',
    position: 'Operations Director, CleanSweep Services',
  },
];

const industries = {
  title: 'Our Industries',
  description: `Explore the diverse sectors that benefit from Orcatec’s specialized software solutions. From carpet cleaning to broader service management, our tools are designed to boost efficiency and enhance customer satisfaction across various industries.
  `,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Carpet Cleaning Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: route_img,
        alt: 'Optimized Route Planning',
      },
      href: '#',
      tag: 'Optimized Route Planning',
      title: 'Minimize Costs and Save Time on the Road',
      text: `Reduce operational costs and improve service timeliness with intelligent route planning and management.`,
      list: [
        {
          text: 'Automatically find the best routes to minimize travel costs and time.',
        },
        {
          text: 'Adjust routes in real-time based on traffic conditions and emergency call-outs.',
        },
        {
          text: 'Assign jobs based on proximity and technician availability to reduce downtime and fuel costs.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: estimate_img,
        alt: 'Enhanced Field Service Management',
      },
      href: '#',
      tag: 'Enhanced Field Service Management',
      title: 'Empower Your Team to Perform Better On-Site',
      text: `Boost field efficiency and customer satisfaction with tools that enhance on-site service capabilities.`,
      list: [
        {
          text: 'Enable staff to build estimates on-site, ensuring accuracy and immediacy.',
        },
        {
          text: 'Collect signatures directly on the device to approve estimates and confirm job completions.',
        },
        {
          text: 'Schedule new appointments directly from the field, maximizing team productivity and responsiveness.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: invoicing,
        alt: 'Simplified Billing & Invoicing ',
      },
      href: '#',
      tag: 'Simplified Billing & Invoicing',
      title: 'Streamline Payment Processes with Ease',
      text: `Effortlessly manage financial transactions with features that simplify the payment process and enhance billing accuracy.`,

      list: [
        {
          text: 'Allow customers to process payments directly through the application, speeding up transactions and reducing administrative hassles.',
        },
        {
          text: 'Generate invoices automatically after job completion, ensuring timely and accurate billing.',
        },
        {
          text: 'Ensure customer data security with encrypted transaction processing.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Comprehensive Customer History',
      },
      href: '#',
      tag: 'Comprehensive Customer History',
      title: 'Access Critical Data for Improved Service',
      text: `Deliver personalized and more effective services by leveraging detailed historical customer data.`,
      list: [
        {
          text: 'Access all relevant customer data and a complete job history to tailor services effectively.',
        },
        {
          text: 'Gain insights from past interactions to enhance customer relationship management and service personalization.',
        },
        {
          text: 'Track the frequency, type, and results of services to offer customized recommendations and promotions.',
        },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Carpet Cleaning Software',
  title: {
    first_part: 'Be Sure to Improve Your Future',
    second_part: 'Carpet Cleaning Operations',
  },
  description: `Our state-of-the-art software can easily revolutionize your carpet-cleaning business due to its desire to streamline each existing aspect of future operations. Our platform can start from simple scheduling and customer management and finish with the invoicing process and feedback collection. It helps to ensure that your team will spend less time on paperwork and can focus more time on delivering outstanding service. `,
  info: [
    { title: '70%', description: 'Reduction in administrative tasks' },
    { title: '25%', description: 'Increase in customer retention rates' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1,
    alt: 'What is Carpet Cleaning Software?',
  },
  title: 'What is Carpet Cleaning Software?',
  description: `The carpet cleaning software is tailored specifically for the industry, enhancing operational efficiency and user-friendliness to address common challenges. The software offers automated scheduling, customer relationship management, and real-time job tracking through a robust cloud technology platform. Key features and benefits of the Orcatec proposal include:`,
  item: [
    {
      title: '',
      description:
        'Simplify appointment setting and finances with drag-and-drop scheduling and automatic invoice generation.',
    },
    {
      title: '',
      description:
        'Integrated communication tools ensure consistent and effective contact with customers, enhancing satisfaction.',
    },
    {
      title: '',
      description:
        'Carpet cleaning business management software addresses scheduling conflicts, inadequate customer communication, and financial management complexities.',
    },
    {
      title: '',
      description:
        'Features like customizable customer profiles and feedback mechanisms help maintain high customer satisfaction and loyalty.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'What makes Orcatec the right choice for carpet cleaning contractors?',
  },
  title: 'What makes Orcatec the right choice for carpet cleaning contractors?',
  description: `Orcatec's free carpet cleaning software is the industry standard because it combines flexibility, customization, accessibility, and cost-effectiveness.`,
  item: [
    {
      title: '',
      description: `Orcatec's free starter package offers a low-cost entry point, allowing contractors to test and evaluate the software without financial commitment. This feature particularly appeals to small to medium businesses looking to enhance operational efficiency without upfront costs.`,
    },
    {
      title: '',
      description: `Due to Orcatec’s flexible payment options, contractors can tailor their software expenditures based on their needs. So, only users choose which features they want to pay for and avoid spending on functionalities they do not need. Such a model ensures that businesses only invest in tools directly contributing to their operational goals.`,
    },
    {
      title: '',
      description: `The carpet cleaning management software is designed with customization in mind, enabling contractors to adjust its functionalities better to fit their business processes and customer handling methods.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `This blog is your premier destination for insights and updates on enhancing your carpet cleaning business. With our expert advice, you can stay ahead of the competition and keep your business sparkling!`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Let us guide you to experience in appliance repair management software! Orcatec team is here to help you. Our experts are ready to amplify your operational efficiency.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
